import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CreateStore from './Redux/CreateStore';
import { Provider } from 'react-redux';
import { applyShortLink } from './Utils/ShortLinks';
import { recordAttribution } from './Utils/Attribution';

// Before render, so analytics and the router only ever see the tagged destination.
applyShortLink();
// After the rewrite, so a short link is remembered by its own tags.
recordAttribution();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={CreateStore}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
